import { ReactComponent as WarningIcon } from "../../assets/icons/warning.svg";
import violationStyles from "../../styles/UI/violation.module.css";
import labels from "../../utils/labels";
import { getViolationMessagesFromViolationName } from "../../utils/violationUtils";

const ViolationBox = ({
  violations,
  violationOnUnplannedTask,
}: {
  violations: Record<string, string>[];
  violationOnUnplannedTask?: boolean;
}) => {
  return (
    <div className={violationStyles.violationBox}>
      <div className="pt-[3px]"><WarningIcon width={14} height={14} /></div>
      <ul className={violationStyles.violationBoxList}>
        {violations.map((violationItem, index) => (
          <li key={index} className={violationStyles.violationBoxListItem}>
            <div className="flex gap-[var(--spacing-xs)]">
              <h4 className={violationStyles.violationBoxTitle}> {violationOnUnplannedTask ? labels.unplannedTask : labels.violation}</h4>
              {getViolationMessagesFromViolationName(violationItem["name"])}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ViolationBox;